import styled, { keyframes } from "styled-components";
import { paletas } from "../../styles/theme";

const animacaoLogo = keyframes`
  from {
    opacity: 0;
    transform: rotate(45deg) scale(-1);
  }
  to {
    opacity: 1;
    transform: rotate(0deg) scale(1);
  }
`;

const animacaoTexto = keyframes`
  0% {
    opacity: 0;
    left: -20px;
    transform: scaleY(-1);
  }
  50% {
    opacity: 1;
    left: 0px;
    transform: scaleY(1);
  }
  70% {
    opacity: 1;
    left: -10px;
  }
  80% {
    opacity: 1;
    left: 0px;
  }
  90% {
    opacity: 1;
    left: -5px;
  }
  100% {
    opacity: 1;
    left: 0px;
  }
`;

export const Wrapper = styled.div`
  width: 80px;
  height: 50px;
  padding: 5px 0;
`;

export const Icon = styled.div`
  animation: 1s ${animacaoLogo};
  position: relative;
  text-align: center;
  width: 60px;
  height: 30px;
  margin: 0 auto -10px;

  & div {
    display: inline-block;
    width: 0.2rem;
    margin: 0 0.05rem;
    border-radius: 0.25rem;
    border: 1px solid white;
    z-index: 1;
  }
  & div:nth-child(1) {
    height: 0.8rem;
  }
  & div:nth-child(2) {
    height: 0.9rem;
  }
  & div:nth-child(3) {
    height: 0.8rem;
  }
  & div:nth-child(4) {
    height: 0.6rem;
  }
  & div:nth-child(5) {
    position: absolute;
    left: 22px;
    top: 14px;
    height: 0.5rem;
    z-index: -1;
    border-color: ${paletas.RedTheme};
    background: ${paletas.RedTheme};
    transform: rotate(100deg);
    -webkit-transform: rotate(100deg);
  }
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    width: 10px;
    height: 10px;
    top: -4px;
    left: 20px;
    border-width: 0 0 1px 0;
    border-style: double;
    border-color: ${paletas.RedTheme};
    border-radius: 50%;
    transform: rotate(250deg);
  }
  &:after {
    content: "";
    position: absolute;
    z-index: -1;
    width: 27px;
    height: 15px;
    left: 15px;
    top: 7px;
    border-width: 0 0 2px 1px;
    border-style: double;
    border-color: ${paletas.RedTheme};
    border-radius: 50%;
  }
`;

export const Titulo = styled.div`
  position: relative;
  animation: 1s ${animacaoTexto};
  color: ${paletas.White};
  padding: 5px;

  & strong {
    color: ${paletas.RedTheme};
  }
`;
